<template>
  <div
    class="hero is-fullheight has-background-light"
    :style="`opacity: ${isAuthenticated ? '1' : '0'};`"
  >
    <section id="app">
      <topbar />
      <div class="container">
        <div class="columns">
          <div class="column is-3 is-hidden-mobile">
            <navbar />
          </div>
          <div class="column">
            <mobile-navbar />
            <div class="section" style="padding: 0 1.5rem 0 1.5rem">
              <router-view />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Topbar from "@/components/Topbar.vue";
import MobileNavbar from "@/components/MobileNavbar.vue";
import { mapGetters, mapActions } from "vuex";
import { userManager } from "@/auth.service";
import qs from "qs";
import axios from "axios";
import { appSettings } from "@/app.settings";
import guid from "@/guid";
export default {
  components: {
    Navbar,
    Topbar,
    MobileNavbar,
  },
  computed: {
    ...mapGetters(["username", "isAuthenticated"]),
  },
  data() {
    return {
      isInactive: false,
      userActivityThrottlerTimeout: null,
      userActivityTimeout: null,
    };
  },
  methods: {
    ...mapActions(["removeUser"]),
    signout() {
      let url = "/oauth2/end_session";
      const id = guid.newGuid();
      axios
        .post(
          url,
          qs.stringify({
            id_token_hint: this.$store.state.idToken,
            state: id,
          }),
          {
            headers: {
              "content-type": "application/x-www-form-urlencoded;charset=utf-8",
            },
          }
        )
        .then(
          (resp) => {
            if (id === resp.data.state) {
              this.$store.dispatch("removeUser");
              userManager.signinRedirect();
            }
          },
          (err) => {
            console.log(err);
            this.$store.dispatch("removeUser");
            userManager.signinRedirect();
          }
        );
    },
    activateActivityTracker() {
      window.addEventListener("mousemove", this.userActivityThrottler);
      window.addEventListener("scroll", this.userActivityThrottler);
      window.addEventListener("keydown", this.userActivityThrottler);
      window.addEventListener("resize", this.userActivityThrottler);
    },

    deactivateActivityTracker() {
      window.removeEventListener("mousemove", this.userActivityThrottler);
      window.removeEventListener("scroll", this.userActivityThrottler);
      window.removeEventListener("keydown", this.userActivityThrottler);
      window.removeEventListener("resize", this.userActivityThrottler);
    },
    resetUserActivityTimeout() {
      clearTimeout(this.userActivityTimeout);

      this.userActivityTimeout = setTimeout(() => {
        this.userActivityThrottler();
        this.inactiveUserAction();
      }, appSettings.idleTimeoutInMinutes * 60 * 1000);
    },
    userActivityThrottler() {
      if (this.isInactive) {
        this.isInactive = false;
        this.signout();
      }

      if (!this.userActivityThrottlerTimeout) {
        this.userActivityThrottlerTimeout = setTimeout(() => {
          this.resetUserActivityTimeout();
          clearTimeout(this.userActivityThrottlerTimeout);
          this.userActivityThrottlerTimeout = null;
        }, 1000);
      }
    },
    inactiveUserAction() {
      this.isInactive = true;
    },
  },
  beforeMount() {
    if (appSettings.idleTimeoutInMinutes) {
      this.activateActivityTracker();
    }
  },
  created() {
    axios.interceptors.response.use(
      (resp) => resp,
      (err) => {
        let status = err.response.status;
        if (status == 401) {
          this.$store.dispatch("removeUser");
          userManager.signinRedirect().catch((err) => {
            console.log(err);
          });
        }        
        return Promise.reject(err);
      }
    );
    axios.interceptors.request.use(
      function (config) {
        if (appSettings.publicPath) {
          config.url = appSettings.publicPath + config.url;
        }
        return config;
      },
      function (error) {
        return Promise.reject(error);
      }
    );    
  },
  mounted() {
    let style = document.createElement("link");
    style.rel = "stylesheet";
    style.href = appSettings.baseUrl + "/personal/api/v1/custom_css/lk-client.css";
    document.head.appendChild(style);
  },
  beforeDestroy() {
    if (appSettings.idleTimeoutInMinutes) {
      this.deactivateActivityTracker();
      clearTimeout(this.userActivityTimeout);
      clearTimeout(this.userActivityThrottlerTimeout);
    }
  },
};
</script>
